<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div
    id="vehicle-list"
    class="col-sm-12 pl-3 pr-3 pb-4"
  >
    <Transition name="fade">
      <div
          v-if="tableItems && tableItems.length > 0"
        class="col-sm-12 list-content result-table"
      >
          <vue3-datatable
              ref="resultTable"
              :rows="tableItems"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              :height="tableItems.length > 8 ? '65vh' : '100%'"
              :sortable="true"
              skin="bh-table-compact"
              :row-class="getRowClass"
              cell-class="routa-table-cell"
              @row-click="emitEdit"
          >
              <template #empty>
                  <div class="text-center my-2">
                      {{ $t('area_report.no_results') }}
                  </div>
              </template>
              <template #start_date="row">
                  {{ row.value.start_date ? getShortDateWithoutTimezone(row.value.start_date) : '' }}
              </template>
              <template #end_date="row">
                  {{ row.value.end_date ? getShortDateWithoutTimezone(row.value.end_date) : '' }}
              </template>
              <template #task_types="row">
                  <div
                      v-if="row.value && row.value.is_contract_party"
                      class="nopads"
                  >
                      <div v-if="!row.value.task_types || row.value.task_types.length < 1">
                          <span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" :title="$t('contracts.no_task_types')">
                              <font-awesome-icon
                                  :id="'contract'+row.value.id"
                                  icon="exclamation-circle"
                                  class="ban"
                              />
                          </span>
                      </div>
                      <div v-else-if="checkOrders(row.value)">
                          <span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" :title="$t('contracts.no_ongoing_orders')">
                              <font-awesome-icon
                                  :id="'contract'+row.value.id"
                                  icon="exclamation-circle"
                                  class="defect"
                              />
                          </span>
                      </div>
                  </div>
              </template>
          </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>
import {orderStatus, workManagementHelper} from '../mixins/WorkManagementMixin'
import {timeUtils} from '../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'ContractList',
    components: {Vue3Datatable},
    mixins: [timeUtils, workManagementHelper],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'tasktype',
            sortDesc: false,
            tableItems: [],
            loading: false
        }
    },
    computed: {
        fields() {
            return [
                {field: 'task_types', title: "", sort: true, headerClass: 'routa-table-header'},
                {field: 'id', title: 'Id', sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'name', title: this.$t('contracts.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract_number', title: this.$t('contracts.number'), sort: true, headerClass: 'routa-table-header'},
                {field: 'customer', title: this.$t('contracts.customer'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contractor', title: this.$t('orders.contractor'), sort: true, headerClass: 'routa-table-header'},
                {field: 'start_date', title: this.$t('contracts.start'), sort: true, headerClass: 'routa-table-header'},
                {field: 'end_date', title: this.$t('contracts.end'), sort: true, headerClass: 'routa-table-header'},
                {field: 'harja_contract_id', title: this.$t('contracts.harja_contract_id'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
        results: function () {
            this.initTableItems()
        }
    },
    mounted: function () {
        this.initTableItems()
    },
    methods: {
        getRowClass(row) {
            const closeDate = row.end_date ? this.getStartOfTheDay(new Date(row.end_date)) : null
            const now = this.getStartOfTheDay(new Date())
            return !closeDate || closeDate.getTime() >= now.getTime() ? 'routa-table-row' : 'routa-table-row expired-row'
        },

        initTableItems() {
            this.tableItems = []
            const temp = []
            if (this.results) {
                this.results.forEach(item => {
                    let newItem = {...item}; // Create a shallow copy of the item
                    newItem._rowVariant = Date.parse(item.end_date) < Date.now() ? 'secondary' : ''
                    newItem.customer = item.customer ? item.customer.name : ''
                    newItem.contractor = item.contractor ? item.contractor.name : ''
                    temp.push(newItem)
                })
            }
            this.$nextTick(() => this.tableItems = temp)
        },
        checkOrders(item) {
            if(!item.task_types || item.task_types.length < 1) {
                return false
            } else if(item.task_types) {
                let noOngoingOrderTaskTypes = 0;
                let orders = 0
                item.task_types.forEach(tt => {
                    orders += tt.orders.length
                    noOngoingOrderTaskTypes += tt.orders.filter(order => order.status !== orderStatus.OPEN &&
                        order.status !== orderStatus.IN_PROGRESS).length
                })
                return noOngoingOrderTaskTypes === orders
            }
        },
        emitEdit: function (result) {
            let item = this.results.find(item => result.id === item.id)
            if (item) {
                this.$emit('edit', item)
            }
        }
    }
}
</script>
